module.exports = __webpack_public_path__ + "img/course_250.ede00222.webp";